export default __webpack_public_path__ + "static/media/GratefulForMyBody2021.fabfd710.png";